import script from "./payModel.vue?vue&type=script&setup=true&lang=js"
export * from "./payModel.vue?vue&type=script&setup=true&lang=js"

import "./payModel.vue?vue&type=style&index=0&id=564f99db&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-564f99db"]])

export default __exports__